export default "__VITE_ASSET__DN$kkcLH__"